/** Auto generated API client entry file for auth */
import { Configuration } from '@rbx/clients';
import { AuthenticationApi } from '@rbx/clients/auth';
import unifiedLoggerClient from '@modules/eventStream/implementations/unifiedLoggerClient';
import { getBEDEV1ServiceBasePath, getRobloxDomain } from '@modules/utilities/constants/baseUrl';

export class AuthClassClient {
  private authenticationAPI: AuthenticationApi;

  constructor(basePathAuth: string = getBEDEV1ServiceBasePath('auth')) {
    const defaultConfiguration = new Configuration({
      robloxSiteDomain: getRobloxDomain(),
      basePath: basePathAuth,
      credentials: 'include',
      unifiedLogger: unifiedLoggerClient,
    });

    this.authenticationAPI = new AuthenticationApi(defaultConfiguration);
  }

  async logout(): Promise<void> {
    await this.authenticationAPI.v1LogoutPost();
  }
}

const authClient = new AuthClassClient();

const basePath = getBEDEV1ServiceBasePath('auth');

const configuration = new Configuration({
  robloxSiteDomain: getRobloxDomain(),
  basePath,
  credentials: 'include',
  unifiedLogger: unifiedLoggerClient,
});
const authenticationApi = new AuthenticationApi(configuration);

export const AuthClient = { authenticationApi };
export default authClient;
